import React from 'react';
import { Grid, icons, Typography } from '@lamimed/pantheon';

import * as S from './styles';

interface Condition {
  icon?: string; // TODO: include it
  title: string;
  description: string;
}

interface Props {
  conditions: Condition[];
}

export const Conditions: React.FC<Props> = ({ conditions }) => {
  return (
    <Grid.Wrapper>
      <S.Row>
        {conditions.map((condition, i) => (
          <S.Column key={`condition-${i}`}>
            {!!condition.icon &&
              Object.keys(icons).includes(condition.icon) && (
                <S.Circle>
                  {React.createElement(
                    icons[condition.icon as keyof typeof icons],
                    {
                      height: 30,
                      width: 30,
                      color: 'light',
                    },
                  )}
                </S.Circle>
              )}

            <S.Content>
              <S.Title variant="heading_4" color="text__highlight">
                {condition.title}
              </S.Title>

              <Typography>{condition.description}</Typography>
            </S.Content>
          </S.Column>
        ))}
      </S.Row>
    </Grid.Wrapper>
  );
};
